import * as React from "react";
import type { SVGProps } from "react";
const SvgInflatableFlamingo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.46 11.31A9.4 9.4 0 0 1 13.895 15H5.24A3.24 3.24 0 0 0 2 18.24v.52A3.24 3.24 0 0 0 5.24 22h13.52A3.24 3.24 0 0 0 22 18.76v-.52q0-.078-.004-.154L22 18c0-3-2.21-5.77-3.82-7.76a21 21 0 0 1-1.33-1.76c-.12-.21-.06-.32-.06-.32a.9.9 0 0 1 .75-.29 1.3 1.3 0 0 1 .93.5c.311.34.476.79.46 1.25a1 1 0 0 0 1.84.66A9.1 9.1 0 0 0 22 6c0-1.38-1.25-4-6-4a4.7 4.7 0 0 0-5 5 8.87 8.87 0 0 0 1.46 4.31m4.16.18c.857 1.056 1.831 2.26 2.512 3.531A3 3 0 0 0 18.76 15h-2.842a11.1 11.1 0 0 0-1.708-4.65A7.2 7.2 0 0 1 13 7a2.72 2.72 0 0 1 3-3q.735.002 1.307.089a5 5 0 0 0-.747 1.904A2.82 2.82 0 0 0 15 7.19a2.25 2.25 0 0 0 .15 2.3q.676 1.043 1.47 2m1.963-5.419A3.2 3.2 0 0 1 19.9 7q.097-.495.1-1c0-.274-.172-.757-.73-1.18a3.1 3.1 0 0 0-.687 1.251M5.24 17A1.23 1.23 0 0 0 4 18.24v.52A1.23 1.23 0 0 0 5.24 20h13.52A1.23 1.23 0 0 0 20 18.76v-.52A1.23 1.23 0 0 0 18.76 17z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInflatableFlamingo;
